export type DntFieldKind = 'email' | 'domain';

export const MAX_ENTRIES = 500;

export const EMAIL_REGEX: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const DOMAIN_REGEX: RegExp =
  /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i;

export function isValidEmail(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length > 0 && EMAIL_REGEX.test(trimmed);
}

export function isValidDomain(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length > 0 && DOMAIN_REGEX.test(trimmed);
}

export function normalizeEntry(value: string): string {
  return value.trim().toLowerCase();
}

export function normalizeEntries(entries: readonly string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const entry of entries) {
    const normalized = normalizeEntry(entry);
    if (normalized.length > 0 && !seen.has(normalized)) {
      seen.add(normalized);
      result.push(normalized);
    }
  }
  return result;
}

export function extractDomainFromEmail(email: string): string | null {
  const idx = email.lastIndexOf('@');
  if (idx === -1) {
    return null;
  }
  const domain = email.slice(idx + 1).toLowerCase();
  return domain.length > 0 ? domain : null;
}

export interface DntValidationResult {
  isValid: boolean;
  error?: string;
}

export function validateEntry(
  value: string,
  kind: DntFieldKind
): DntValidationResult {
  const normalized = normalizeEntry(value);
  if (normalized.length === 0) {
    const error =
      kind === 'email'
        ? 'Enter a valid email address (e.g. user@example.com)'
        : 'Enter a bare domain (e.g. example.com – no protocol or path)';
    return { isValid: false, error };
  }
  if (kind === 'email') {
    if (!isValidEmail(normalized)) {
      return {
        isValid: false,
        error: 'Enter a valid email address (e.g. user@example.com)',
      };
    }
  } else {
    if (!isValidDomain(normalized)) {
      return {
        isValid: false,
        error: 'Enter a bare domain (e.g. example.com – no protocol or path)',
      };
    }
  }
  return { isValid: true };
}
